import { AutofocusDirective } from '../../../../../../shared/directive/autofocus.directive';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import { FormBaseComponent } from '@anihis/shared/src/shared/base-components/form-base.component';
import isEqual from 'lodash/isEqual';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { DentalImageDogComponent } from './dental-image-dog/dental-image.component';
import { DentalImageCat } from './dental-image-cat/dental-image-cat';
import { Validators, ReactiveFormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'anihis-dental-record',
  standalone: true,
  imports: [
    AutofocusDirective,
    CommonModule,
    DentalImageDogComponent,
    DentalImageCat,
    MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatTableModule,
    MatTooltipModule,
    TranslocoModule,
  ],
  templateUrl: './dental-record.component.html',
  styleUrl: './dental-record.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DentalRecordComponent extends FormBaseComponent implements OnInit {
  @Output() formChange = new EventEmitter<any>();

  legends = [
    { name: 'Tooth repair', color: '#31a34a' },
    { name: 'Tooth extracted', color: '#ed1c24' },
    { name: 'Prosthesis', color: '#1976d2' },
    { name: 'Teeth cleaning', color: '#ffc107' },
    { name: 'Prosthesis and teeth cleaning', color: '#f57c00' },
  ];

  displayedColumns: string[] = ['Kvadrant', 'GD', 'GL', 'DD', 'DL'];
  dataSource = [
    {
      kvadrant: 'Plaque',
      gdControl: 'plaqueGD',
      glControl: 'plaqueGL',
      ddControl: 'plaqueDD',
      dlControl: 'plaqueDL',
    },
    {
      kvadrant: 'Calculus',
      gdControl: 'calculusGD',
      glControl: 'calculusGL',
      ddControl: 'calculusDD',
      dlControl: 'calculusDL',
    },

    {
      kvadrant: 'Gingivitis',
      gdControl: 'gingivitisGD',
      glControl: 'gingivitisGL',
      ddControl: 'gingivitisDD',
      dlControl: 'gingivitisDL',
    },
    {
      kvadrant: 'Periodontitis',
      gdControl: 'periodontitisGD',
      glControl: 'periodontitisGL',
      ddControl: 'periodontitisDD',
      dlControl: 'periodontitisDL',
    },
  ];

  override ngOnInit(): void {
    this.form = this.fb.group({
      animalType: ['cat', Validators.required],
      plaqueGD: [''],
      plaqueGL: [''],
      plaqueDD: [''],
      plaqueDL: [''],
      calculusGD: [''],
      calculusGL: [''],
      calculusDD: [''],
      calculusDL: [''],
      gingivitisGD: [''],
      gingivitisGL: [''],
      gingivitisDD: [''],
      gingivitisDL: [''],
      periodontitisGD: [''],
      periodontitisGL: [''],
      periodontitisDD: [''],
      periodontitisDL: [''],
      comments: [''],
      extractedTooth: [],
      cleaningTooth: [],
      prosthesis: [],
      repairTooth: [],
    });
    this.form.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged(isEqual))
      .subscribe((value) => {
        this.formChange.emit(value);
      });
  }

  onStateReport(report: any): void {
    this.form.patchValue({
      extractedTooth: report['active'],
      repairTooth: report['repair-tooth-active'],
      cleaningTooth: report['cleaning-tooth-active'],
      prosthesis: report['prosthesis-active'],
    });
  }

  clearForm() {
    this.form.reset();
  }
}
